var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "app_list",
    staticClass: "app-list"
  }, [_c('Apps', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.detail.visible,
      expression: "!detail.visible"
    }],
    attrs: {
      "type": "manage",
      "showMore": _vm.showMore
    },
    on: {
      "on-jump": _vm.jump
    }
  }), _c('AppDetail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.detail.visible,
      expression: "detail.visible"
    }],
    attrs: {
      "visible": _vm.detail.visible,
      "item": _vm.detail.item
    },
    on: {
      "close": _vm.close
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };